module.exports = __webpack_public_path__ + "img/PSLRLOC.8b202fd4.svg";